export const PACKAGE_MANAGEMENT_URL = process.env.REACT_APP_PACKAGE_MANAGEMENT_URL?.trim() ?? '';
export const OMS_URL = process.env.REACT_APP_OMS_URL?.trim() ?? '';
export const UPLOAD_SERVICE_URL = process.env.REACT_APP_UPLOAD_SERVICE_URL?.trim() ?? '';
export const MDS_URL = process.env.REACT_APP_MDS_URL?.trim() ?? '';
export const TENANT_MANAGEMENT_URL = process.env.REACT_APP_TENANT_MANAGEMENT_URL?.trim() ?? '';

export const AUTH_STRATEGY = {
  SECRET_KEY: 'secret-key',
  BEARER_TOKEN: 'bearer-token',
};

export const services = {
  packageManagement: {
    baseUrl: PACKAGE_MANAGEMENT_URL,
    authStrategy: AUTH_STRATEGY.SECRET_KEY,
    secretKey: process.env.REACT_APP_PACKAGE_MANAGEMENT_SECRET_KEY ?? '',
  },
  oms: {
    baseUrl: OMS_URL,
    authStrategy: AUTH_STRATEGY.BEARER_TOKEN,
    tenant: process.env.REACT_APP_OMS_TENANT ?? '',
  },
  uploadService: {
    baseUrl: UPLOAD_SERVICE_URL,
    authStrategy: AUTH_STRATEGY.SECRET_KEY,
    secretKey: process.env.REACT_APP_UPLOAD_SERVICE_SECRET_KEY ?? '',
  },
  mds: {
    baseUrl: MDS_URL,
    authStrategy: AUTH_STRATEGY.BEARER_TOKEN,
  },
  tenantManagement: {
    baseUrl: TENANT_MANAGEMENT_URL,
    authStrategy: AUTH_STRATEGY.BEARER_TOKEN,
  },
};
